import axios from "axios";

const targets = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getMasterTargets() {
            let response = await axios.get(`/get_master_targets`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getTargetGoodsInfo(context, payload) {
            let response = await axios.get(`/get_target_goods_info/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async copyFromLastTarget() {
            let response = await axios.get(`/copy_from_last_target`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default targets;
